import { call, put } from "redux-saga/effects";
import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";

import {
  getMessagingServiceError,
  getMessagingServiceSuccess,
} from "../actions/messaging";

export function* getMessagingServiceSaga(action) {
  const { flux, code } = action;
  try {
    const messages = yield call(ClaroSDKService.messagerService, flux, code);
    yield put(getMessagingServiceSuccess(messages));
  } catch (error) {
    return yield put(getMessagingServiceError(error));
  }
}
